import { Injectable } from '@angular/core';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { BriefingSendAtModel } from '../models/briefing-send-at.model';

/**
 * Helper to assist in localizing recurrance type description
 */
@Injectable()
export class BriefingSendNowHelper {

    constructor(private localizationService: LocalizationService) {}

    /**
     * Compiles a localized description of the recurrance type
     *
     * @param briefingSendAt the model to provide localization tokens
     *
     * @returns string - the description
     */
    public getRecurranceLocalization(briefingSendAt: BriefingSendAtModel): string {
        const descriptionKeys = briefingSendAt.recurring.getRecurrenceDescription();
        let description = this.localizationService.transform(descriptionKeys[0]);
        if (descriptionKeys.length === 1) {

            return description;
        }
        description += ' (';

        for (let i = 1; i < descriptionKeys.length; i++) {
            const test = this.localizationService.transform(descriptionKeys[i]);
            description += test;
            if (i !== descriptionKeys.length - 1) {
                description += ', ';
            }
        }
        description += ')';

        return description;
    }
}
